@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-brands/glass-house-variant-type-and-label/glass-house-variant-type-and-label.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
:host .glass-house-variant-type-and-label {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
}
:host .glass-house-variant-type-and-label .glass-house-variant-type {
  font-family: onest, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.375rem;
  line-height: 100%;
  letter-spacing: 3.52px;
  text-transform: uppercase;
}
:host .glass-house-variant-type-and-label .glass-house-label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
:host .glass-house-variant-type-and-label .glass-house-label ::ng-deep .product-label {
  font-family: onest, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 0.625rem;
  width: fit-content;
  margin: 0;
  border-radius: 0.125rem;
}
/*# sourceMappingURL=glass-house-variant-type-and-label.component.css.map */
